<div class="searchBlock" *ngIf="pageShowSearch !== 'false'">
  <div class="searchSection"><i class="icon-search"></i>
    <div class="searchtxt">
      <input [formControl]='searchQuery' id="searchStoryCollectionPage" class="search-components textBox" type="text"
        placeholder="Search Stories &amp; Elements..." [(ngModel)]="str" (focus)="searchFocus = true"
        (focusout)="searchFocus = false" autofocus />
    </div>
  </div>
  <div class="filterSection spImg">
    <div class="fliterBlock">
      <i class="icon-filter"></i>
      <ul class="filterOption">
        <ng-container *ngIf="filterList !== 'false' && facets ">
          <ng-container *ngFor="let filter of filterList;let i = index">
            <ng-container *ngIf="filter.name != 'Status' && filter.name != 'Page Status'">
              <li class="togfilt" *ngIf="(i < 5)">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetNameMeta]="filter.facet_name_meta" [facetName]="filter.facet_name"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)" [isDataKeyValuePair]="filter.isDataKeyValuePair"></filter>
              </li>
              <span [class]="((showMore) ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more')"
                (click)="(showMore = !showMore)" *ngIf="(i === 5 && i > 4)">{{(showMore) ? 'less' : 'more'}}</span>
              <li class="togfilt" *ngIf="(i > 4  && showMore)">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetNameMeta]="filter.facet_name_meta" [facetName]="filter.facet_name"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)" [isDataKeyValuePair]="filter.isDataKeyValuePair"></filter>
              </li>
            </ng-container>
          </ng-container>
        </ng-container>
      </ul>
    </div>
    <div class="closebg"></div>
  </div>
</div>

<div (scroll)="onScroll($event)" [ngClass]="(pagePinList) ? 'allLiveList' : 'allcontentList'" #autoscroll>
  <ul>
    <ng-container *ngIf="showCollectonData;then showCollection else pinList"> </ng-container>
    <ng-template #pinList>
      <div class='container relative' *ngIf="(pagePinList)" [dragula]='"six-bag"'
      id="pin" [dragulaModel]='pagePinList'
        [dragulaOptions]="options">
        <ng-container *ngFor="let pinItem of pagePinList;let i = index">
          <li *ngIf="pinItem.article?.title" id="{{pinItem.article.id}}">
            <div class="heading pin">
              <span class="number" *ngIf=pagePinList>{{i+1}}</span>
              <span [innerHTML]="htmlToPlaintext(pinItem.article.title)"></span>

              <i class="icon-pin active" id="{{pinItem.article.id}}" *ngIf=pagePinList
                (click)="pushStory(pinItem.article,true)"></i>
            </div>
            <div class="relatedcount"
              *ngIf="pinItem.article && pinItem.article.related && pinItem.article.related.length > 0">
              <span>Show related stories in line-up</span>
              <div class="checkoption" *ngIf="pageShowSearch == 'false'">
                <div [class]="(pinItem && pinItem.article && pinItem.article.showRelated && (pinItem.article.showRelated === true)) ? 'slidelabel yesslide' : 'slidelabel'" tabindex="0"
                (keydown)="callToggles($event, pinItem.article?.id, pinItem.article?.showRelated, pinItem.article?.lockedByUserName)"
                (click)="toggleSwitch(pinItem.article?.id,pinItem.article?.showRelated, pinItem.article?.lockedByUserName)">
                <span class="tat"></span>
                <span [class]="(pinItem && pinItem.article && pinItem.article.showRelated && (pinItem.article.showRelated === true)) ? 'tat checked' : 'tat'"></span>
              </div>
              </div>
            </div>
            <div class="status">
              <ul>
                <li> <span
                    class="time">{{pinItem.article.lastModifiedDate !== '-'?getNewTypeVersionDateTime(pinItem.article.lastModifiedDate):'-'}}</span>
                </li>
                <li *ngIf="pinItem.article.metadata?.section"> <span
                    class="section">{{pinItem.article.metadata?.section}}</span> </li>
                <li> <span class="format">{{pinItem.article?.type}}</span> </li>
                <li *ngIf='(pinItem.article.metadata?.breakingNews)'> <em class="breakingnews icon-breaking"></em> </li>
                <li *ngIf='(pinItem.article.metadata?.sponsored)'><em class="sponsored icon-Combined-Shape"></em></li>
                <li *ngIf=!pagePinList>
                  <a [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + item.id : ''">
                    <span class="viewEye"><i class="icon-view-image"></i></span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="pinned">
              <span class="pinneduntill">Pinned until
                <span class="pindate" id="{{pinItem.article.id}}Pin">
                  <span class="setTime" name="daterangeInput" id="modelIdForTime1" daterangepicker
                    [options]="singleCalendarConfig" (click)="showCalendarfn()"
                    (selected)="selectedDate($event,pinItem.article.id,pinItem.position)">{{pinItem.expireAt !== '-'?getFullDate(pinItem.expireAt):'-'}}</span>

                </span>
              </span>
              <span class="pinnedPosition" *ngIf="domainConfig['config'] && domainConfig['config']['collection'] && domainConfig['config']['collection']['setPositionEnabled']">
                <span *ngIf="(pinItem.position != 0 || setPositionClickedId == pinItem.article.id)">Position : </span>
                <span class="setPosition" *ngIf="(setPositionClickedId != pinItem.article.id && pinItem.position == 0)" (click)="setPositionClicked(pinItem)">Set Position</span>
                
                <span class="positionLabel" *ngIf="((pinItem.position != 0 && pinItem.position != null && pinItem.position != undefined) && setPositionClickedId != pinItem.article.id)" (click)="setPositionClicked(pinItem)"> {{pinItem.position}}</span>
                
                <input autocomplete="off" [id]="pinItem.article.id+'-position-input'" *ngIf="(setPositionClickedId == pinItem.article.id)" type="text" (keydown)="validatePositionKeyPress($event)" (keyup)="validateMaxPositionValue($event)" 
                [value]="(pinItem.position == null || pinItem.position == undefined || pinItem.position == 0) ? '' : pinItem.position">
                <span class="tickIcon" *ngIf="(setPositionClickedId == pinItem.article.id)" (click)="positionValueChanged(pinItem.article.id, pinItem.expireAt)"><i class="icon-checkbox-tick"></i></span>
              </span>
            </div>
          </li>
        </ng-container>
        <div class="lockbg" *ngIf="showCalendar"></div>
      </div>
    </ng-template>
    <ng-template #showCollection>
      <ng-container *ngIf="showPage == 'page';then showPageDropList else pinDropList"> </ng-container>
      <ng-template #showPageDropList>
        <div dragula="second-bag" style="min-height: 600px;" id="rightp" class='container'>
          <li *ngIf="(showPageTopic || showPageSection || showPageSubSection || showPageCompany) && !multiplePageFlag">
            <div class="heading pin">
             {{showPageName}}
            </div>
            <div class="status">
              <ul>
                <li class="deleteStoryIcon"> <span class="deleteHeadline">
                    <i class="icon-delete" (click)="pageToDelete()"></i></span> </li>
              </ul>
            </div>
          </li>
          <li *ngIf="multiplePageFlag">
            <ng-container *ngFor="let  page of pageList">
              <div class="heading pin">
                {{page.name}}
              </div>
              <div class="status">
                <ul>
                  <li class="deleteStoryIcon"> <span class="deleteHeadline">
                      <i class="icon-delete" (click)="pagesToDelete(page.id)"></i></span> </li>
                </ul>
              </div>
            </ng-container>
          </li>
        </div>
      </ng-template>
      <ng-template #pinDropList>
        <!-- collectionArray -->
        <div class='container' style="height: calc(100vh - 175px );" [dragula]='"another-bag"' [id]="dragulaId"
          [dragulaModel]='articleList' [dragulaOptions]="options">
          <ng-container *ngFor="let pinItem of collectionPinList;let i = index">
            <li *ngIf="pinItem.article?.title" id="{{pinItem.article.id}}">
              <div class="heading pin">
                <span class="number" *ngIf=pagePinList>{{i+1}}</span>
                <span [innerHTML]="htmlToPlaintext(pinItem.article.title)"></span>
  
                <i class="icon-pin active" id="{{pinItem.article.id}}" *ngIf=pagePinList
                  (click)="pushCollection(pinItem.article,true)"></i>
              </div>
              <div class="relatedcount"
                *ngIf="pinItem.article && pinItem.article.related && pinItem.article.related.length > 0">
                <span>Show related stories in line-up</span>
                <div class="checkoption" *ngIf="pageShowSearch == 'false'">
                  <div [class]="(pinItem && pinItem.article && pinItem.article.showRelated && (pinItem.article.showRelated === true)) ? 'slidelabel yesslide' : 'slidelabel'" tabindex="0"
                  (keydown)="callToggles($event, pinItem.article?.id, pinItem.article?.showRelated, pinItem.article?.lockedByUserName)"
                  (click)="toggleSwitch(pinItem.article?.id,pinItem.article?.showRelated, pinItem.article?.lockedByUserName)">
                  <span class="tat"></span>
                  <span [class]="(pinItem && pinItem.article && pinItem.article.showRelated && (pinItem.article.showRelated === true)) ? 'tat checked' : 'tat'"></span>
                </div>
                </div>
              </div>
              <div class="status">
                <ul>
                  <li> <span
                      class="time">{{pinItem.article.lastModifiedDate !== '-'?getNewTypeVersionDateTime(pinItem.article.lastModifiedDate):'-'}}</span>
                  </li>
                  <li *ngIf="pinItem.article.metadata?.section"> <span
                      class="section">{{pinItem.article.metadata?.section}}</span> </li>
                  <li> <span class="format">{{pinItem.article?.type}}</span> </li>
                  <li *ngIf='(pinItem.article.metadata?.breakingNews)'> <em class="breakingnews icon-breaking"></em> </li>
                  <li *ngIf='(pinItem.article.metadata?.sponsored)'><em class="sponsored icon-Combined-Shape"></em></li>
                  <li *ngIf=!pagePinList>
                    <a [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + item.id : ''">
                      <span class="viewEye"><i class="icon-view-image"></i></span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="pinned">
                <span class="pinneduntill">Pinned until
                  <span class="pindate" id="{{pinItem.article.id}}Pin">
                    <span class="setTime" name="daterangeInput" id="modelIdForTime1" daterangepicker
                      [options]="singleCalendarConfig" (click)="showCalendarfn()"
                      (selected)="selectedDate($event,pinItem.article.id,pinItem.position)">{{pinItem.expireAt !== '-'?getFullDate(pinItem.expireAt):'-'}}</span>
  
                  </span>
                </span>
                <span class="pinnedPosition" *ngIf="domainConfig['config'] && domainConfig['config']['collection'] && domainConfig['config']['collection']['setPositionEnabled']">
                  <span *ngIf="(pinItem.position != 0 || setPositionClickedId == pinItem.article.id)">Position : </span>
                  <span class="setPosition" *ngIf="(setPositionClickedId != pinItem.article.id && pinItem.position == 0)" (click)="setPositionClicked(pinItem)">Set Position</span>
                  
                  <span class="positionLabel" *ngIf="((pinItem.position != 0 && pinItem.position != null && pinItem.position != undefined) && setPositionClickedId != pinItem.article.id)" (click)="setPositionClicked(pinItem)"> {{pinItem.position}}</span>
                  
                  <input autocomplete="off" [id]="pinItem.article.id+'-position-input'" *ngIf="(setPositionClickedId == pinItem.article.id)" type="text" (keydown)="validatePositionKeyPress($event)" (keyup)="validateMaxPositionValue($event)" 
                  [value]="(pinItem.position == null || pinItem.position == undefined || pinItem.position == 0) ? '' : pinItem.position">
                  <span class="tickIcon" *ngIf="(setPositionClickedId == pinItem.article.id)" (click)="positionValueChanged(pinItem.article.id, pinItem.expireAt)"><i class="icon-checkbox-tick"></i></span>
                </span>
              </div>
            </li>
          </ng-container>
          <ng-container *ngFor="let pinItem of articleList;let i = index">
            <li *ngIf="pinItem && i < 100" id="{{pinItem.id}}" value="{{i}}" >
              <div class="heading pin">
                <span class="number">{{collectionPinList.length + i + 1}}</span>
                <span [innerHTML]="htmlToPlaintext(pinItem?.title)"></span>
                <i class="icon-pin" id="{{pinItem.id}}" *ngIf=pagePinList (click)="pushCollection(pinItem,false)"></i>
              </div>
              <div class="status">
                <ul>
                  <li> <span
                      class="time">{{pinItem.lastModifiedDate !== '-'?getNewTypeVersionDateTime(pinItem.lastModifiedDate):'-'}}</span>
                  </li>
                  <li *ngIf="pinItem.metadata?.section"> <span class="section">{{pinItem.metadata?.section}}</span>
                  </li>
                  <li> <span class="format">{{pinItem?.type}}</span> </li>
                  <li *ngIf='(pinItem.metadata.breakingNews)'> <em class="breakingnews icon-breaking"></em> </li>
                  <li *ngIf='(pinItem.metadata.sponsored)'><em class="sponsored icon-Combined-Shape"></em> </li>
                  <li class="deleteStoryIcon"> <span class="deleteHeadline"><i class="icon-delete"
                        (click)="idToDelete(pinItem.id)"></i></span> </li>
                </ul>
              </div>
            </li>
          </ng-container>
        </div>
      </ng-template>
    </ng-template>
    <ng-container *ngIf="showPage == 'page' && listArray.length > 0">
      <div dragula="second-bag" id="leftp" class='container'>
        <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
          <li *ngIf="showPage == 'page'" id="{{item.alias}}" title="{{item.name}}"
          slot="{{item.parentSection?.alias}}" [class]="toggleFade(item)" type="{{item.pageType}}">
            <div class="heading pin" id="{{item.id}}">
              <span [innerHTML]="htmlToPlaintext(item.name)"></span>
              <i class="icon-pin" id="{{item.id}}" *ngIf=pagePinList (click)="pushStory(item,false)"></i>
            </div>
            <div class="status">
              <ul>
                <ng-container *ngIf="showPage == 'page'">
                  <li *ngIf="item.pageType == 'SUBSECTION'">
                    <span class="sectioncollection">{{item?.url.replace('/', '')}}</span> </li>
                  <li *ngIf="item.pageType"> <span class="format">{{item.pageType}}</span> </li>
                </ng-container>
                <ng-container *ngIf="showPage == 'story' || showPage == 'elements'">
                  <li> <span
                      class="time">{{item.lastModifiedDate !== '-'?getNewTypeVersionDateTime(item.lastModifiedDate):'-'}}</span>
                  </li>
                  <li *ngIf="item.metadata?.section"> <span class="section">{{item.metadata?.section}}</span> </li>
                  <li *ngIf="item.pageType"> <span class="format">{{item.pageType}}</span> </li>
                </ng-container>
                <li *ngIf='(item.metadata?.breakingNews)'> <em class="breakingnews icon-breaking"></em> </li>
                <li *ngIf='(item.metadata?.sponsored)'> <em class="sponsored icon-Combined-Shape"></em> </li>
                <li *ngIf="!pagePinList">
                  <a [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + item.id : ''">
                    <span class="viewEye"><i class="icon-view-image"></i></span>
                  </a></li>
              </ul>
            </div>
          </li>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="showPage == 'story' || showPage == 'elements'">
      <div class='container' *ngIf="!showCollectonData" style="height: calc(100vh - 175px );" [dragula]='"another-bag"'
        [id]="dragulaId" [dragulaModel]='listArray' [dragulaOptions]="options">
        <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
          <li id="{{item?.id}}" value="{{i}}" title="{{item?.type}}" accessKey="{{item.domainId}}" *ngIf="i < count && item?.title"
            [class]="domainWiseDisableDrag(item)">
            <div class="heading pin">
              <span class="number" *ngIf=pagePinList>{{pagePinList.length + i + 1}} </span>
              <span [innerHTML]="htmlToPlaintext(item?.title)"></span>
              <i class="icon-pin" id="{{item?.id}}" *ngIf=pagePinList (click)="pushStory(item,false)"></i>
            </div>
            <div class="relatedcount" *ngIf="item?.related && item?.related.length > 0">
              <ng-container *ngIf="pageShowSearch == 'false'">
                <span>Show related stories in line-up</span>
                <div class="checkoption">
                  <div [class]="(item && item.showRelated && (item.showRelated === true)) ? 'slidelabel yesslide' : 'slidelabel'" tabindex="0"
                    (keydown)="callToggles($event, item?.id, item?.showRelated, item?.lockedByUserName)"
                    (click)="toggleSwitch(item?.id,item?.showRelated, item?.lockedByUserName)">
                    <span class="tat"></span>
                    <span [class]="(item && item.showRelated && (item.showRelated === true)) ? 'tat checked' : 'tat'"></span>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="pageShowSearch !== 'false' && !inCollection">
                <span>{{item?.related.length}} related stories</span>
              </ng-container>
            </div>

            <div class="status">
              <ul>
                <li> <span class="time">
                    {{item?.lastModifiedDate !== '-'?getNewTypeVersionDateTime(item?.lastModifiedDate):'-'}}</span> </li>
                <li *ngIf='(item?.metadata?.section)'> <span class="section">{{item?.metadata?.section}}</span> </li>
                <li *ngIf='(item?.type)'> <span class="format">{{item?.type}}</span> </li>
                <li *ngIf='(item?.metadata?.breakingNews)'> <em class="breakingnews icon-breaking"></em> </li>
                <li *ngIf='(item?.metadata?.sponsored)'> <em class="sponsored icon-Combined-Shape"></em> </li>
                <li class="deleteStoryIcon" *ngIf="pagePinList"> <span class="deleteHeadline"><i class="icon-delete"
                      (click)="idToDelete(item.id)"></i></span> </li>
                <li *ngIf="!pagePinList && !isTemplateView && item.domainId === domain ">
                  <a [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + item.id : ''">
                    <span class="viewEye">
                      <i class="icon-view-image"></i></span>
                  </a>
                </li>

              </ul>
            </div>
            <!-- <div class="dropPinned" *ngIf="pagePinList">
              <span class="pinnedPosition">Position: <input type="text" placeholder="Enter Value"></span>
           </div> -->
            <!-- <div class="checkStatus" *ngIf="isTemplateView">
                <label class="checkblock" tabindex="0">
                  <input type="checkbox"  [disabled]="((isInArray.indexOf(item.id) > -1) ? true : isTemplateFilled)"  (click)="templateToggle(item)" [checked]="(isInArray.indexOf(item.id) > -1)">
                  <span class="checkmark"></span>
                </label>
              </div> -->
          </li>
        </ng-container>
      </div>

    </ng-container>
  </ul>
</div>
<div [class]="((matchPopup) ? 'lightBox embeddblock matchBlock block' : 'lightBox embeddblock matchBlock')"
*ngIf="pageShowSearch === 'false' && matchPopup">
<app-match-component (sendPopupValueToParentfn)="getPopupValueToParentfn($event)"
(sendMatchDetailsToParentfn) = getMatchDetailsToParentfn($event)
></app-match-component>
</div>
